export default "__VITE_ASSET__CXtvQNAr__"